/* eslint-disable no-nested-ternary */
import React, { useState, Fragment, useEffect, useMemo } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Checkbox, Divider, Drawer, Dropdown, Select, Table, Tag, Tooltip,
} from 'antd';
import {
  SwapLeftOutlined, SwapRightOutlined, SwapOutlined, ControlOutlined, FilterOutlined,
} from '@ant-design/icons';
import { toISTDate } from '@Apis/constants';
import H3Text from '@Uilib/h3Text';
import STActions from '@Actions/stActions';
import Helpers from '@Apis/helpers';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import searchIcon from '@Images/icons/icon-search.png';
import H3Image from '@Uilib/h3Image';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import ViewTableCustomFields from '@Components/Common/CustomField/ViewTableCustomFields';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import SelectDepartment from '@Components/Common/SelectDepartment';
import closeIcon from '@Images/icons/icon-close-blue.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesRight } from '@fortawesome/free-solid-svg-icons';
import PRZText from '../../../Common/UI/PRZText';
import MoreInfoMobileView from '../../../Common/MoreInfoMobileView';
import PRZSelect from '../../../Common/UI/PRZSelect';
import useCheckPortrait from '../../../../hooks/useCheckPortrait';
import './style.scss';
import { entityNameEnum, filterTypeEnums } from '../../../../apis/constants';
import UserSavedFilterViewSelector from '../../../Common/UserSavedFilterViewSelector';

const { Option } = Select;

function StockTransferList({
  stockTransfer, getStLoading, user, getSt, history, getDocCFV2Loading, customFieldsProps, getDocCFV2, getDocCFV2Success, departments,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [selectedTenant, setSelectedTenant] = useState('');
  const [isUserReady, setIsUserReady] = useState(false);
  const [recievingStatus, setRecievingStatus] = useState('');
  const [fixedColumns, setFixedColumns] = useState(['STOCK_TRANSFER_NO']);
  const [selectedStatus, setSelectedStatus] = useState('');
  const [selectedTransfer, setSelectedTransfer] = useState('');
  const [moreDetailsDrawer, setMoreDetailsDrawer] = useState(false);
  const [visibleColumns, setVisibleColumns] = useState(localStorage.getItem('prcz-page-columns-st') ? JSON.parse(localStorage.getItem('prcz-page-columns-st')) : {
    STOCK_TRANSFER_NO: {
      label: 'Stock Transfer#',
      visible: true,
    },
    TRANSFER_TYPE: {
      label: 'Transfer Type',
      visible: true,
    },
    FROM_LOCATION: {
      label: 'From Location',
      visible: true,
    },
    TO_LOCATION: {
      label: 'To Location',
      visible: true,
    },
    ITEMS: {
      label: 'Items',
      visible: true,
    },
    CREATED_DATE: {
      label: 'Created Date',
      visible: true,
    },
    ST_DATE: {
      label: 'Transfer Date',
      visible: true,
    },
    STATUS: {
      label: 'Status',
      visible: true,
    },
    ATTACHMENTS: {
      label: 'Attachments',
      visible: true,
    },
    RECEIVING_STATUS: {
      label: 'Receiving Status',
      visible: true,
    },
  });
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [departmentLevelVisibility, setDepartmentLevelVisibility] = useState(false);
  const [currentDefaultView, setCurrentDefaultView] = useState({});
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState([]);
  const [selectedFilterView, setSelectedFilterView] = useState({});
  const [isUserReadyInitial, setIsUserReadyInitial] = useState(false);
  const [isUpdateFilterSate, setIsUpdateFilterSate] = useState(true);
  const [savedFilterViews, setSavedFilterViews] = useState([]);
  const [savedFilterViewsLoading, setSavedFilterViewsLoading] = useState(false);

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();
  /**
   *
   * @param {*} word
   * @param {*} pg
   * @param {*} size
   */
  const pushParamsToUrl = (page, pgSize, currentTenant, word, receivingStatus, status, dept, selectedFilterView) => {
    let url = '';
    if (page) url += `?page=${page}`;
    if (pgSize) url += `&limit=${pgSize}`;
    if (currentTenant) url += `&tenant=${currentTenant}`;
    if (word) url += `&keyword=${word}`;
    if (status) url += `&status=${status}`;
    if (receivingStatus) url += `&receiving_status=${receivingStatus}`;
    if (dept) url += `&department=${dept}`;
    history.push(url);
  };

  const getTableColumns = () => {
    const tableColumns = [
      // {
      //   title: '',
      //   responsive: ['xs'],
      //   render: (record) => (
      //     <Link to={`/inventory/stock-transfer/view/${record.stock_transfer_id}`}>
      //       {' '}
      //       <div className="mobile-list__item">
      //         <div
      //           style={{
      //             display: 'flex', justifyContent: 'space-between',
      //           }}
      //         >
      //           <div
      //             style={{
      //               display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', gap: '7%',
      //             }}
      //             className=""
      //           >

      //             <div>{record?.stock_transfer_number}</div>

      //             <div className="">
      //               {record?.source_department_info?.tenant_id === record?.destination_department_info?.tenant_id && (
      //                 <div className="st-type-tag" style={{ backgroundColor: '#5287da' }}>
      //                   <SwapOutlined />
      //                   <H3Text text="Internal" className="#5287da" />
      //                 </div>
      //               )}
      //               {record?.source_department_info?.tenant_id !== record?.destination_department_info?.tenant_id
      //                 && record?.source_department_info?.tenant_id === user?.tenant_info?.tenant_id
      //                 && (
      //                   <div className="st-type-tag" style={{ backgroundColor: '#f15353' }}>
      //                     <SwapRightOutlined />
      //                     <H3Text text="Outgoing" className="" />
      //                   </div>
      //                 )}
      //               {record?.source_department_info?.tenant_id !== record?.destination_department_info?.tenant_id
      //                 && record?.destination_department_info?.tenant_id === user?.tenant_info?.tenant_id
      //                 && (
      //                   <div className="st-type-tag" style={{ backgroundColor: '#2fbc6e' }}>
      //                     <SwapLeftOutlined />
      //                     <H3Text text="Incoming" className="" />
      //                   </div>
      //                 )}
      //               {record?.source_department_info?.tenant_id !== record?.destination_department_info?.tenant_id
      //                 && record?.destination_department_info?.tenant_id !== user?.tenant_info?.tenant_id
      //                 && record?.source_department_info?.tenant_id !== user?.tenant_info?.tenant_id
      //                 && (
      //                   <div className="st-type-tag" style={{ backgroundColor: '#5287da' }}>
      //                     <SwapLeftOutlined />
      //                     <H3Text text="External" className="" />
      //                   </div>
      //                 )}
      //             </div>
      //           </div>
      //           <div className="qr__status " style={{ backgroundColor: Helpers.getStatusColor(record.status).color }}>{Helpers.getStatusColor(record.status).text}</div>
      //         </div>
      //         <div style={{ marginTop: '10px' }}>
      //           <H3Text text={`From: ${record?.source_department_info?.tenant_name}`} className="mobile-list__item-info" />

      //         </div>
      //         <div>
      //           <H3Text text={`To: ${record?.destination_department_info?.tenant_name}`} className="mobile-list__item-info" />

      //         </div>
      //         <div>
      //           <H3Text text={`Item(s): ${record?.stock_transfer_lines?.length}`} className="mobile-list__item-info" />

      //         </div>
      //         <div>
      //           <H3Text text={`Date: ${toISTDate(record?.created_at).format('DD/MM/YYYY')}`} className="mobile-list__item-info" />

      //         </div>
      //         <div style={{ display: 'flex', gap: '1%' }} className="mobile-list__item-info">
      //           Status:
      //           {' '}
      //           {/* <div style={{ color: Helpers.getStatusColor(record?.stock_receiving_details?.stock_receiving_status).color }}>{` ${Helpers.getStatusColor(record?.stock_receiving_details?.stock_receiving_status).text?.toUpperCase()}`}</div> */}
      //           <div style={{ color: Helpers.getStatusColor(record?.st_receiving_status).color }}>{Helpers.getStatusColor(record?.st_receiving_status).text?.toUpperCase()}</div>
      //         </div>
      //       </div>
      //     </Link>

      //   ),
      // },
      {
        title: '',
        render: (record) => (
          <div className="mobile-list__card">
            <div className="mobile-list__card_header">
              <div className="mobile-list__card_header-left">
                <PRZText className="mobile-list__card_item-number" text={`#${record?.stock_transfer_number ? record.stock_transfer_number : 'N/A'}`} />
              </div>
              <div className="mobile-list__card_header-right">
                <PRZText
                  style={{ backgroundColor: Helpers.getStatusColor(record.status).color }}
                  text={Helpers.getStatusColor(record.status).text?.toUpperCase()}
                  className="mobile-list__card__status"
                />
              </div>
            </div>
            <div className="mobile-list__card_body">
              <div className="mobile-list__card_body-left">
                <PRZText
                  text={`From - ${record?.source_department_info?.tenant_name} (${record?.source_department_info?.alias_name})`}
                  className="mobile-list__card_item-details"
                />
                <PRZText
                  text={`To - ${record?.destination_department_info?.tenant_name} (${record?.destination_department_info?.alias_name})`}
                  className="mobile-list__card_item-details"
                />
                <PRZText
                  text={`Created Date - ${toISTDate(record?.created_at).format('DD/MM/YYYY')}`}
                  className="mobile-list__card_item-details"
                />
                <PRZText
                  text={`Transfer Date - ${toISTDate(record?.stock_transfer_date).format('DD/MM/YYYY')}`}
                  className="mobile-list__card_item-details"
                />
              </div>
              <div className="mobile-list__card_body-right">
                <Tooltip
                  color="white"
                  placement="top"
                  title={(
                    <PRZText className="mobile-list__card_item__tooltip_text-color" text="Items" />
                  )}
                >
                  <PRZText
                    text={record?.lines_count}
                  />
                </Tooltip>
              </div>
            </div>
            <Divider className="mobile-list__card_divider" />
            <div className="mobile-list__card_footer">
              <div className="mobile-list__card_footer-left">
                <Tooltip
                  title={(
                    <PRZText
                      className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                      text="Transfer Type"
                    />
                  )}
                  color="white"
                >
                  <div>
                    {record?.source_department_info?.tenant_id === record?.destination_department_info?.tenant_id && (
                      <div className="st-type-tag" style={{ backgroundColor: '#5287da' }}>
                        <SwapOutlined />
                        <H3Text text="Internal" className="#5287da" />
                      </div>
                    )}
                    {record?.source_department_info?.tenant_id !== record?.destination_department_info?.tenant_id
                      && record?.source_department_info?.tenant_id === user?.tenant_info?.tenant_id
                      && (
                        <div className="st-type-tag" style={{ backgroundColor: '#f15353' }}>
                          <SwapRightOutlined />
                          <H3Text text="Outgoing" className="" />
                        </div>
                      )}
                    {record?.source_department_info?.tenant_id !== record?.destination_department_info?.tenant_id
                      && record?.destination_department_info?.tenant_id === user?.tenant_info?.tenant_id
                      && (
                        <div className="st-type-tag" style={{ backgroundColor: '#2fbc6e' }}>
                          <SwapLeftOutlined />
                          <H3Text text="Incoming" className="" />
                        </div>
                      )}
                    {record?.source_department_info?.tenant_id !== record?.destination_department_info?.tenant_id
                      && record?.destination_department_info?.tenant_id !== user?.tenant_info?.tenant_id
                      && record?.source_department_info?.tenant_id !== user?.tenant_info?.tenant_id
                      && (
                        <div className="st-type-tag" style={{ backgroundColor: '#5287da' }}>
                          <SwapLeftOutlined />
                          <H3Text text="External" className="" />
                        </div>
                      )}
                  </div>
                </Tooltip>
                &nbsp;
                {record?.st_receiving_status && (
                  <Tooltip
                    color="white"
                    title={(
                      <PRZText className="mobile-list__card_item__category__tooltip mobile-list__card_item__tooltip_text-color" text="Receiving Status" />
                    )}
                  >
                    <PRZText
                      className="mobile-list__card_footer__other-status font-11"
                      style={{ color: Helpers.getStatusColor(record?.st_receiving_status)?.color }}
                      text={record.st_receiving_status?.replaceAll('_', ' ')?.toProperCase()}
                    />
                  </Tooltip>
                )}
              </div>
              <div className="mobile-list__card_footer-right">
                <PRZText
                  className="mobile-list__card__view-more_wrapper"
                  onClick={() => {
                    setSelectedTransfer(record);
                    setMoreDetailsDrawer(true);
                  }}
                  text={(
                    <span className="mobile-list__card__view-more-text_wrapper">
                      <span className="mobile-list__card__view-more-text">More Info</span>
                      <FontAwesomeIcon
                        className="mobile-list__card__view-more-icon"
                        icon={faAnglesRight}
                      />
                    </span>
                  )}
                />
              </div>
            </div>
          </div>
        ),
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        title: '#',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (record) => (
          <div className="min-width-50">
            {record?.stock_transfer_number}
          </div>
        ),
        fixed: 'left',
        className: !visibleColumns?.STOCK_TRANSFER_NO?.visible ? 'display-none' : '',
      },
      {
        title: 'TRANSFER TYPE',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (record) => (
          <div className="transfer-type__wrapper min-width-115">
            {record?.source_department_info?.tenant_id === record?.destination_department_info?.tenant_id && (
              <div className="st-type-tag" style={{ backgroundColor: '#5287da' }}>
                <SwapOutlined />
                <H3Text text="Internal" className="#5287da" />
              </div>
            )}
            {record?.source_department_info?.tenant_id !== record?.destination_department_info?.tenant_id
              && record?.source_department_info?.tenant_id === user?.tenant_info?.tenant_id
              && (
                <div className="st-type-tag" style={{ backgroundColor: '#f15353' }}>
                  <SwapRightOutlined />
                  <H3Text text="Outgoing" className="" />
                </div>
              )}
            {record?.source_department_info?.tenant_id !== record?.destination_department_info?.tenant_id
              && record?.destination_department_info?.tenant_id === user?.tenant_info?.tenant_id
              && (
                <div className="st-type-tag" style={{ backgroundColor: '#2fbc6e' }}>
                  <SwapLeftOutlined />
                  <H3Text text="Incoming" className="" />
                </div>
              )}
            {record?.source_department_info?.tenant_id !== record?.destination_department_info?.tenant_id
              && record?.destination_department_info?.tenant_id !== user?.tenant_info?.tenant_id
              && record?.source_department_info?.tenant_id !== user?.tenant_info?.tenant_id
              && (
                <div className="st-type-tag" style={{ backgroundColor: '#5287da' }}>
                  <SwapLeftOutlined />
                  <H3Text text="External" className="" />
                </div>
              )}
          </div>
        ),
        className: !visibleColumns?.TRANSFER_TYPE?.visible ? 'display-none' : '',
      },
      {
        title: 'FROM',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (record) => (
          <div className="min-width-50">
            <H3Text text={(record?.source_department_info?.tenant_name ? `${record?.source_department_info?.tenant_name}` : '')} />
            <H3Text text={(record?.source_department_info ? `${record?.source_department_info?.alias_name}` : '')} className="table-subscript" />
          </div>
        ),
        className: !visibleColumns?.FROM_LOCATION?.visible ? 'display-none' : '',
      },
      {
        title: 'TO',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (record) => (
          <div className="min-width-50">
            <H3Text text={(record?.destination_department_info?.tenant_name ? `${record?.destination_department_info?.tenant_name}` : '')} />
            <H3Text text={(record?.destination_department_info?.alias_name ? `${record?.destination_department_info?.alias_name}` : '')} className="table-subscript" />
          </div>
        ),
        className: !visibleColumns?.TO_LOCATION?.visible ? 'display-none' : '',
      },
      {
        title: 'ITEM(s)',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-50">
            {record?.lines_count}
          </div>
        ),
        className: !visibleColumns?.ITEMS?.visible ? 'display-none' : '',
      },

      {
        title: 'CREATED DATE',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (record) => (
          <div>
            <div className="column-date min-width-100">
              {toISTDate(record?.created_at).format('DD/MM/YYYY')}
            </div>
            <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} className="table-subscript" />
          </div>
        ),
        className: !visibleColumns?.CREATED_DATE?.visible ? 'display-none' : '',
      },
      {
        title: 'TRANSFER DATE',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (record) => (
          <div className="column-date min-width-100">
            {toISTDate(record?.stock_transfer_date).format('DD/MM/YYYY')}
          </div>
        ),
        className: !visibleColumns?.ST_DATE?.visible ? 'display-none' : '',
      },
      {
        title: 'ATTACHMENTS',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-100">
            {
              record?.attachments?.map((item, index) => (
                <div>
                  <a href={item?.url} target="_blank" rel="noreferrer">{`Link# ${index + 1}`}</a>
                </div>
              ))
            }
          </div>
        ),
        className: !visibleColumns?.ATTACHMENTS?.visible ? 'display-none' : '',
      },
      {
        title: 'STATUS',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (item) => (<div className="qr__status min-width-50" style={{ backgroundColor: Helpers.getStatusColor(item.status).color }}>{Helpers.getStatusColor(item.status).text}</div>),
        className: !visibleColumns?.STATUS?.visible ? 'display-none' : '',
      },
      {
        title: 'RECEIVING STATUS',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (item) => (
          <div className="min-width-130" style={{ color: Helpers.getStatusColor(item?.st_receiving_status).color }}>{Helpers.getStatusColor(item?.st_receiving_status).text?.toUpperCase()}</div>
        ),
        className: !visibleColumns?.RECEIVING_STATUS?.visible ? 'display-none' : '',
      },
    ];
    if (customFieldsProps?.data?.document_custom_fields?.length) {
      const customs = customFieldsProps?.data?.document_custom_fields;
      customs?.filter((item) => item?.is_active)?.map((custom) => {
        tableColumns.push({
          title: custom.field_name?.toUpperCase(),
          render: (record) => (
            <div className={Helpers.setColumnMinimumWidth(custom?.field_name)}>
              <ViewTableCustomFields customField={record.custom_fields?.filter((subItem) => subItem.cf_id === custom.cf_id)?.[0]} />
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
          hidden: isMobile,
          className: !visibleColumns?.[custom.cf_id]?.visible ? 'display-none' : '',
        });
      });
    }
    tableColumns.push({
      title: '',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      hidden: isPortrait,
      className: 'list__actions-column',
      fixed: 'right',
      render: (text, record) => (
        <div className="list__actions">
          <div className="list__actions-button list__actions-button-dark" onClick={() => history.push(`/inventory/stock-transfer/view/${record.stock_transfer_id}`)}>
            View
          </div>
        </div>
      ),
    });
    return tableColumns.filter((item) => !item.hidden);
  };

  function getAppliedFiltersFromURL() {
    const appliedFiltersFromURL = [
      {
        filter_key: 'limit',
        filter_value: Number(Helpers.getValueFromUrl('limit') || limit),
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'keyword',
        filter_value: Helpers.getValueFromUrl('keyword') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'tenant',
        filter_value: Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'status',
        filter_value: Helpers.getValueFromUrl('status') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'receiving_status',
        filter_value: Helpers.getValueFromUrl('receiving_status') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'department',
        filter_value: Helpers.getValueFromUrl('department') || '',
        filter_type: filterTypeEnums.STRING,
      },

    ];
    return appliedFiltersFromURL;
  }
  
  const initialFilterValues = useMemo(() => {
    return [
      {
        filter_key: 'limit',
        filter_value: limit,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'keyword',
        filter_value: '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'tenant',
        filter_value: [user?.tenant_info?.tenant_id],
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'status',
        filter_value: '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'receiving_status',
        filter_value: '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'department',
        filter_value: '',
        filter_type: filterTypeEnums.STRING,
      },
    ];
  }, []);

  const systemDefaultUserView = useMemo(() => ({
    filter_id: 'system_default',
    filter_name: 'System Default View',
    entity_name: entityNameEnum.STOCK_TRANSFER,
    filters: initialFilterValues,
    tenant_id: user?.tenant_info?.tenant_id,
    org_id: user?.user_org_id,
    user_id: user?.user_id,
    is_default: false,
    is_system_default: true,
  }), []);
  
  function getFilterValueByKey({ filtersArray, key, valueOnly = true }) {
    const selectedFilter = filtersArray.find((item) => item.filter_key === key) || null;
    return valueOnly ? selectedFilter?.filter_value : selectedFilter;
  }

  useEffect(() => {
    if (savedFilterViews && isUserReadyInitial) {
      const defaultUserView = savedFilterViews.find((item) => item.is_default);

      if (defaultUserView) {
        setCurrentDefaultView(defaultUserView);
      } else {
        setCurrentDefaultView(systemDefaultUserView);
      }

      const appliedFiltersFromURL = getAppliedFiltersFromURL();

      const selectedFilterViewFromURL = Helpers.getValueFromUrl('filter_id');

      let currentSelectedView;
      if (selectedFilterViewFromURL) {
        currentSelectedView = savedFilterViews.find((item) => String(item.filter_id) === String(selectedFilterViewFromURL));
        if (!currentSelectedView) {
          currentSelectedView = systemDefaultUserView;
        }
      } else {
        currentSelectedView = defaultUserView || systemDefaultUserView;
      }

      const filterValues = (isFromURL) => {
        const currentSelectedViewFilters = currentSelectedView.filters;

        const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: filterKey }) }), {});

        return filterValue;
      };

      const tempFilterValues = filterValues(selectedFilterViewFromURL);

      setSelectedFilterView(currentSelectedView);
      if (isUpdateFilterSate) {
        setCurrentlyAppliedFilters(appliedFiltersFromURL);

        setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
        setLimit(tempFilterValues.limit || limit);
        setSearchKeyword(tempFilterValues.keyword);
        setKeyword(tempFilterValues.keyword);
        setSelectedTenant(tempFilterValues.tenant);
        setSelectedStatus(tempFilterValues.status);
        setRecievingStatus(tempFilterValues.receiving_status);
        if (Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility) {
          setDepartmentLevelVisibility(user?.tenant_info?.inventory_config?.settings?.department_wise_visibility);
          setSelectedDepartment(tempFilterValues.department || Helpers.getDepartmentId(user)?.toString());
        } else {
          setSelectedDepartment(tempFilterValues.department);
        }
      }

      if (!isUserReady) setIsUserReady(true);
      if (!isUpdateFilterSate) setIsUpdateFilterSate(true);
    }
  }, [savedFilterViews, isUserReadyInitial]);

  useEffect(() => {
    // if (user?.tenant_info?.org_id) {
    //   setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
    //   setLimit(Number(Helpers.getValueFromUrl('limit') || limit));
    //   setSelectedTenant(Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [user?.tenant_info?.tenant_id]);
    //   setSearchKeyword(Helpers.getValueFromUrl('keyword'));
    //   setKeyword(Helpers.getValueFromUrl('keyword'));
    //   setSelectedStatus(Helpers.getValueFromUrl('status'));
    //   setRecievingStatus(Helpers.getValueFromUrl('receiving_status'));
    //   if (Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility) {
    //     setDepartmentLevelVisibility(user?.tenant_info?.inventory_config?.settings?.department_wise_visibility);
    //     setSelectedDepartment(Helpers.getValueFromUrl('department') || Helpers.getDepartmentId(user)?.toString());
    //   } else {
    //     setSelectedDepartment(Helpers.getValueFromUrl('department'));
    //   }
    //   setIsUserReady(true);
    // }
    return () => {
      getDocCFV2Success(null);
    };
  }, []);

  useEffect(() => {
    if (isUserReady) {
      pushParamsToUrl(currentPage, limit, selectedTenant, searchKeyword, recievingStatus, selectedStatus, selectedDepartment, selectedFilterView);
      const payload = {
        orgId: user?.tenant_info?.org_id,
        entityName: 'STOCK_TRANSFER',
      };
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());
      getDocCFV2(payload);
      getSt(selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.STOCK_TRANSFER, Helpers.permissionTypes.READ)?.join(','), '', Helpers.getValueFromUrl('page'), Helpers.getValueFromUrl('limit'), Helpers.getValueFromUrl('keyword'), Helpers.getValueFromUrl('receiving_status'), Helpers.getValueFromUrl('status'), Helpers.getValueFromUrl('department'));
    }
  }, [selectedTenant, searchKeyword, currentPage, limit, selectedStatus, recievingStatus, selectedDepartment
    // selectedFilterView
  ]);


  useEffect(() => {
    if (customFieldsProps?.data?.document_custom_fields?.length) {
      const customFields = customFieldsProps?.data?.document_custom_fields;
      const columns = JSON.parse(JSON.stringify(visibleColumns));
      customFields?.filter((item) => item?.is_active)?.map((customField) => {
        columns[customField.cf_id] = {
          label: customField?.field_name,
          visible: JSON.parse(localStorage.getItem('prcz-page-columns-st'))?.[customField.cf_id]?.visible || false,
        };
      });
      setVisibleColumns(columns);
    }
  }, [customFieldsProps]);

  const statusOptions = [
    { key: 'DRAFT', value: 'DRAFT', label: 'Draft' },
    { key: 'SENT_FOR_APPROVAL', value: 'SENT_FOR_APPROVAL', label: 'Sent For Approval' },
    { key: 'ISSUED', value: 'ISSUED', label: 'Issued' },
    { key: 'CANCELLED', value: 'CANCELLED', label: 'Cancelled' },
  ];

  const receivedStatusOptions = [
    { key: 0, value: 'RECEIVED', label: 'Received' },
    { key: 1, value: 'NOT_RECEIVED', label: 'Not Received' },
    { key: 2, value: 'PARTIALLY_RECEIVED', label: 'Partially Received' },
  ];

  return (
    <Fragment>
      <Drawer
        open={moreDetailsDrawer}
        mask
        onClose={() => setMoreDetailsDrawer(false)}
        destroyOnClose
        rootClassName="mobile__more-details_wrapper"
      >
        <div className="custom-drawer__header-wrapper">
          <div
            className="custom-drawer__header"
          >
            <H3Text
              text={`MR # ${selectedTransfer?.stock_transfer_number}`}
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setMoreDetailsDrawer(false)}
            />
          </div>
        </div>
        <MoreInfoMobileView
          customFields={selectedTransfer?.custom_fields}
        />
      </Drawer>
      <div className="doc-list__wrapper">
        <div className="ant-row">
          <div className="ant-col-xs-24">
            <div className="doc-list__header-wrapper">
              <div className="doc-list__header-wrapper__left">
                <div className="section-search">
                  <div className="doc-list__search-bar__wrapper">
                    <div className="section-search-bar">
                      <input
                        value={keyword}
                        placeholder="Search for stock transfers..."
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            setSearchKeyword(e.target.value);
                            setCurrentPage(1);
                          }
                        }}
                        onChange={(event) => {
                          setKeyword(event.target.value);
                        }}
                      />
                      <H3Image
                        src={searchIcon}
                        className="section-search-bar__icon"
                        alt="search"
                        onClick={() => {
                          getSt(selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.STOCK_TRANSFER, Helpers.permissionTypes.READ)?.join(','), '', 1, limit, keyword, '');
                          setSearchKeyword(keyword);
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="doc-list__header-wrapper__right">
                {Helpers.getPermission(Helpers.permissionEntities.STOCK_TRANSFER,
                  Helpers.permissionTypes.CREATE, user) && (
                    <div className="doc-list__buttons-wrapper">
                      <H3Button
                        buttonType={defaultButtonTypes.BLUE_ROUNDED}
                        text="+ New Stock Transfer"
                        onClick={() => {
                          history.push('/inventory/stock-transfer/create');
                        }}
                        customClass="add-button"
                      />
                    </div>
                  )}
              </div>
            </div>
            <div className="flex-align-c" style={{ gap: '10px' }}>
              <UserSavedFilterViewSelector
                selectedFilterView={selectedFilterView}
                onChangeTab={(currentSelectedView) => {
                  setSelectedFilterView(() => {
                    const currentSelectedViewFilters = currentSelectedView.filters;

                    const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});

                    const tempFilterValues = filterValue;
                    setCurrentPage(1);
                    setLimit(tempFilterValues.limit || limit);
                    setSearchKeyword(tempFilterValues.keyword);
                    setKeyword(tempFilterValues.keyword);
                    setSelectedTenant(tempFilterValues.tenant);
                    setSelectedStatus(tempFilterValues.status);
                    setRecievingStatus(tempFilterValues.receiving_status);
                    setSelectedDepartment(tempFilterValues.department);
                    return currentSelectedView;
                  });
                }}
                currentlyAppliedFilters={currentlyAppliedFilters}
                entityName={entityNameEnum.STOCK_TRANSFER}
                setSavedFilterViews={(value) => setSavedFilterViews(value)}
                setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
                setIsUpdateFilterSate={(value) => setIsUpdateFilterSate(value)}
                callback={() => {
                  if (!isUserReadyInitial) setIsUserReadyInitial(true);
                }}
                systemDefaultUserView={systemDefaultUserView}
              />
              <div className="header__tags">
                {searchKeyword && (
                  <Tag closable onClose={() => { setSearchKeyword(''); setKeyword(''); setCurrentPage(1); }} color="#2d7df7">
                    Search results for -
                    &nbsp;
                    <span><b><i>{searchKeyword}</i></b></span>
                  </Tag>
                )}
                {selectedTenant && selectedTenant?.map((item) => (
                  <Tag
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSelectedTenant(selectedTenant.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Business Unit -
                    &nbsp;
                    <span>
                      <b>{user?.user_tenants?.find((tenant) => tenant?.tenant_id == item)?.tenant_name?.toUpperCase()}</b>
                    </span>
                  </Tag>
                ))}
                {selectedStatus && (
                  <Tag closable onClose={() => { setSelectedStatus(''); setCurrentPage(1); }} color="#2d7df7">
                    Status -
                    &nbsp;
                    <span><b>{selectedStatus?.split('_').join(' ').toUpperCase()}</b></span>
                  </Tag>
                )}
                {recievingStatus
                  && (
                    <Tag closable onClose={() => { setRecievingStatus(''); }} color="#2d7df7">
                      Receiving Status -
                      &nbsp;
                      <span><b>{recievingStatus?.replaceAll('_', ' ')}</b></span>
                    </Tag>
                  )}
                {!!selectedDepartment && (
                  <Tag closable={!departmentLevelVisibility} onClose={() => { setSelectedDepartment(null); setCurrentPage(1); }} color="#2d7df7">
                    {' '}
                    Department -
                    &nbsp;
                    <span><b>{departments?.data?.result?.departments?.find((item) => Number(item?.department_id) === Number(selectedDepartment))?.department_info?.department_name?.toUpperCase()}</b></span>
                  </Tag>
                )}
                {/* { */}
                {/*  (startDateMomentEpoch && endDateMomentEpoch) ? ( */}
                {/*      <Tag */}
                {/*          closable */}
                {/*          onClose={() => { */}
                {/*            setStartDateMomentEpoch(null); */}
                {/*            setEndDateMomentEpoch(null); */}
                {/*          }} */}
                {/*          color="#2d7df7" */}
                {/*      > */}
                {/*        {' '} */}
                {/*        From: */}
                {/*        &nbsp; */}
                {/*        <span><b>{dayjs(startDateMomentEpoch).format('DD/MM/YYYY')}</b></span> */}
                {/*        &nbsp; */}
                {/*        To: */}
                {/*        &nbsp; */}
                {/*        <span><b>{dayjs(endDateMomentEpoch).format('DD/MM/YYYY')}</b></span> */}
                {/*      </Tag> */}
                {/*  ) : '' */}
                {/* } */}
              </div>
            </div>
            <div className="doc-list__table-wrapper">
              <Table
                title={() => (
                  <div className="doc-list__table-header">
                    <div className="doc-list__table-header__left">
                      <H3Text text={`${(stockTransfer && stockTransfer?.count) ? stockTransfer?.count : '0'} Transfer Orders`} className="" />
                    </div>
                    <div className="doc-list__table-header__right">
                      <div className="doc-list__filter-buttons">
                        <Dropdown
                          trigger={['click']}
                          overlay={(
                            <div className="header__filter__container">
                              <div className="header__filter__container__title">
                                Apply Filters
                              </div>
                              <div className="filter__container filter__container-section">
                                <div className="filter__title">Business Unit</div>
                                <TenantSelector
                                  selectedTenant={selectedTenant}
                                  showSearch
                                  showAll
                                  onChange={(value) => {
                                    setSelectedTenant(value);
                                  }}
                                  placeholder="Select Business Unit"
                                  isMultiple
                                  hideTitle
                                  includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.STOCK_TRANSFER, Helpers.permissionTypes.READ)}
                                />
                              </div>
                              <div className="filter__container filter__container-section">
                                <div className="filter__title"> Select Department </div>
                                <div className="sales-orders__header__section-status">
                                  <SelectDepartment
                                    title="Select Department"
                                    hideTitle
                                    selectedDepartment={Number(selectedDepartment) || ''}
                                    noDropdownAlign
                                    onChange={(value) => {
                                      setSelectedDepartment(value?.department_id.toString() || '');
                                      setCurrentPage(1);
                                    }}
                                    disabled={departmentLevelVisibility}
                                  />
                                </div>
                              </div>
                              <div className="filter__container filter__container-section">
                                <div className="filter__title">Status</div>
                                <PRZSelect
                                  value={selectedStatus}
                                  onChange={(value) => {
                                    setSelectedStatus(value);
                                    setCurrentPage(1);
                                  }}
                                  placeholder="Search by Status.."
                                  className="purchase-orders__table-header__filter"
                                  options={statusOptions}
                                />
                              </div>
                              <div className="filter__container filter__container-section">
                                <div className="filter__title">Receiving Status </div>
                                <PRZSelect
                                  value={recievingStatus}
                                  disabled={getStLoading}
                                  onChange={(value) => { setRecievingStatus(value); }}
                                  placeholder=""
                                  options={receivedStatusOptions}
                                />
                              </div>
                            </div>
                          )}
                        >
                          <div className="action-buttons">
                            <div className="action-button">
                              <H3Text text="Filters" className="action-button-text" />
                              <FilterOutlined />
                            </div>
                          </div>
                        </Dropdown>

                        <Dropdown
                          overlay={(
                            <div className="custom-columns__content">
                              <div className="custom-columns__content-section">
                                <H3Text text="Visible Columns" className="custom-columns__content-title" />
                                {
                                  Object.keys(visibleColumns).filter((item) => visibleColumns[item]?.visible)?.map((key) => (
                                    <div key={key}>
                                      <Checkbox
                                        disabled={fixedColumns.includes(key)}
                                        checked={visibleColumns[key]?.visible}
                                        onChange={() => {
                                          const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                          visibleColumnsCopy[key].visible = !visibleColumns[key].visible;
                                          localStorage.setItem('prcz-page-columns-st', JSON.stringify(visibleColumnsCopy));
                                          setVisibleColumns(visibleColumnsCopy);
                                        }}
                                      >
                                        {visibleColumns[key]?.label}
                                      </Checkbox>
                                    </div>
                                  ))
                                }
                              </div>
                              {Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.length ? (
                                <div className="custom-columns__content-section">
                                  <H3Text text="Hidden Columns" className="custom-columns__content-title" />
                                  {
                                    Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.map((key) => (
                                      <div key={key}>
                                        <Checkbox
                                          disabled={fixedColumns.includes(key)}
                                          checked={visibleColumns[key]?.visible}
                                          onChange={() => {
                                            const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                            visibleColumnsCopy[key].visible = !visibleColumns[key].visible;
                                            localStorage.setItem('prcz-page-columns-st', JSON.stringify(visibleColumnsCopy));
                                            setVisibleColumns(visibleColumnsCopy);
                                          }}
                                        >
                                          {visibleColumns[key]?.label}
                                        </Checkbox>
                                      </div>
                                    ))
                                  }
                                </div>
                              ) : ''}
                            </div>
                          )}
                          trigger={['click']}
                          placement="bottomRight"
                        >
                          <div className="custom-columns__wrapper">
                            Customize Columns
                            <ControlOutlined />
                          </div>
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                )}
                loading={getStLoading || getDocCFV2Loading || savedFilterViewsLoading}
                showHeader
                size="small"
                scroll={!isMobileOrPortrait && stockTransfer && !!stockTransfer?.result?.stock_transfers?.length ? { x: 'max-content', y: 'calc(100dvh - 180px)' } : { x: 'max-content' }}
                sticky={!isMobileOrPortrait && stockTransfer && !!stockTransfer?.result?.stock_transfers?.length}
                columns={getTableColumns()}
                dataSource={stockTransfer && stockTransfer?.result?.stock_transfers ? stockTransfer?.result?.stock_transfers : []}
                bordered
                pagination={
                  {
                    defaultCurrent: currentPage,
                    current: currentPage,
                    total: stockTransfer ? stockTransfer?.count : 0,
                    pageSize: limit,
                    onChange: (page, pgSize) => {
                      setCurrentPage(page);
                      setLimit(pgSize);
                    },
                    position: ['bottomLeft'],
                    showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                    showSizeChanger: true,
                    pageSizeOptions: [10, 25, 50, 100],
                  }
                }
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, STReducers, CFV2Reducers, DepartmentReducers,
}) => ({
  user: UserReducers.user,
  getStLoading: STReducers.getStLoading,
  stockTransfer: STReducers.stockTransfer,
  getDocCFV2Loading: CFV2Reducers.getDocCFV2Loading,
  customFieldsProps: CFV2Reducers.cfV2DocStockTransfer,
  departments: DepartmentReducers.departments,
});

const mapDispatchToProps = (dispatch) => ({
  getSt: (tenantId, stId, page, limit, searchKeyword, receivingStatus, status, department, callback) => dispatch(STActions.getSt(tenantId, stId, page, limit, searchKeyword, receivingStatus, status, department, callback)),
  getDocCFV2: (paylaod, callback) => dispatch(CFV2Actions.getDocCFV2(paylaod, callback)),
  getDocCFV2Success: (cf) => dispatch(CFV2Actions.getDocCFV2Success(cf)),
});

StockTransferList.propTypes = {
  getSt: PropTypes.func,
  stockTransfer: PropTypes.any,
  user: PropTypes.any,
  getStLoading: PropTypes.bool,
  history: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(StockTransferList));
